export default "__VITE_ASSET__7a702782__"